
import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface QuickReplyOption {
  id: string;
  label: string;
  value: any;
  ageRange?: string;
  yearRange?: string;
  isCurrent?: boolean;
}

interface QuickReplyButtonsProps {
  options: QuickReplyOption[];
  onSelect: (value: any) => void;
}

const QuickReplyButtons = ({ options, onSelect }: QuickReplyButtonsProps) => {
  const { t } = useTranslation('memory');

  return (
    <div className="flex flex-col gap-2 max-h-64 md:max-h-80 overflow-y-auto scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent">
      {options.map((option, index) => (
        <motion.button
          key={option.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.1 }}
          onClick={() => onSelect(option.value)}
          className="relative w-full px-4 py-3 bg-white/60 hover:bg-white/80 backdrop-blur-sm border border-white/30 rounded-xl text-left font-medium text-gray-800 hover:text-gray-900 transition-colors duration-200"
        >
          {/* Current phase badge - absolutely positioned */}
          {option.isCurrent && (
            <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs px-1.5 py-0.5 rounded-full z-10">
              {t('chat.now')}
            </span>
          )}
          
          {/* Main content - structured layout */}
          <div className="flex flex-col">
            <span className="font-medium text-sm">
              {option.label}
            </span>
            {(option.ageRange || option.yearRange) && (
              <div className="flex flex-col mt-1 space-y-0.5">
                {option.ageRange && (
                  <span className="text-xs text-gray-600">{option.ageRange}</span>
                )}
                {option.yearRange && (
                  <span className="text-xs text-gray-600">{option.yearRange}</span>
                )}
              </div>
            )}
          </div>
        </motion.button>
      ))}
    </div>
  );
};

export default QuickReplyButtons;
